export const emptyCalendarState = {
  users: [],
  holidays: [],
}
